const it = {
  meta: {
    siteName: "Nieder-Eschbacher Pflegedienst GmbH",
    titleSuffix: "Nieder-Eschbacher Pflegedienst",
    description:
      "Nieder-Eschbacher Pflegedienst GmbH, servizio di assistenza domiciliare a Francoforte sul Meno. Assistenza a domicilio attenta e competente: cura della persona, assistenza infermieristica, aiuto domestico e reperibilità 24 ore su 24.",
    pages: {
      home: "",
      about: "Chi siamo",
      services: "Servizi",
      news: "Novità e offerte di lavoro",
      contact: "Contatti",
      imprint: "Note legali",
      privacy: "Informativa sulla privacy",
      notFound: "Pagina non trovata",
    },
  },

  common: {
    call: "Chiama",
    callNow: "Chiamaci:",
    contactUs: "Contattaci",
    bookConsultation: "Prenota una consulenza",
    bookAppointment: "Fissa un appuntamento",
    requestConsultation: "Richiedi una consulenza",
    aroundTheClock: "24 ore su 24:",
    reachable24h: "Reperibili 24 ore su 24",
    certifiedStaff: "Personale infermieristico qualificato",
    whatsapp: "WhatsApp",
    whatsappText: "Buongiorno, ho una domanda sul vostro servizio di assistenza.",
    whatsappNote: "Non inviate dati sulla salute tramite WhatsApp. In caso di emergenza chiamateci.",
    symbolImage: "Immagine illustrativa",
    language: "Lingua",
    changeLanguage: "Scegli la lingua",
    skipToContent: "Vai al contenuto",
    legalNote: "Questa traduzione ha solo scopo informativo. Fa fede la versione tedesca.",
  },

  header: {
    topbar24h: "Reperibili 24 ore",
    topbarConsult: "Consulenza gratuita e personale",
    mainNav: "Navigazione principale",
    mobileNav: "Navigazione mobile",
    openMenu: "Apri il menu",
    closeMenu: "Chiudi il menu",
  },

  nav: {
    home: "Home",
    about: "Chi siamo",
    services: "Servizi",
    news: "Novità",
    contact: "Contatti",
    jobs: "Offerte di lavoro",
    imprint: "Note legali",
    privacy: "Privacy",
  },

  footer: {
    reach: "Come raggiungerci",
    fax: "Fax:",
    emergency: "Numero di emergenza 24 ore:",
    navigation: "Navigazione",
    legal: "Informazioni legali",
    area: "Francoforte sul Meno e dintorni (in particolare Nieder-Eschbach)",
    rights: "Tutti i diritti riservati.",
  },

  floating: {
    whatsappLabel: "Scriveteci su WhatsApp",
    callLabel: "Chiamaci:",
    toTop: "Torna su",
  },

  home: {
    eyebrow: "Servizio di assistenza domiciliare · Francoforte sul Meno",
    h1a: "Assistenza attenta e competente",
    h1b: "a casa vostra",
    lead:
      "Per una vita serena, anche quando l'età o la malattia richiedono assistenza. Noi ci prendiamo il tempo per voi.",
    heroImgAlt: "Un'operatrice del Nieder-Eschbacher Pflegedienst appoggia le mani sulle spalle di un signore anziano sorridente; accanto logo e servizi: assistenza di base, cure infermieristiche, aiuto domestico, assistenza individuale",
    badgeTitle: "Con il cuore e con calma",
    badgeText: "Un'assistenza che si prende il suo tempo",
    welcomeQuote:
      "Noi, il team del Nieder-Eschbacher Pflegedienst di Francoforte sul Meno, siamo lieti del vostro interesse. Giorno dopo giorno ci impegniamo per le persone che ci danno fiducia e offriamo un'assistenza di qualità nella privacy della vostra casa. Il nostro personale cordiale si prende il tempo per voi.",
    features: [
      {
        icon: "Clock",
        title: "Ci prendiamo il tempo",
        text: "Un approccio premuroso, senza fretta. Vogliamo che vi sentiate a vostro agio con noi.",
        to: "about",
        cta: "Chi siamo",
      },
      {
        icon: "HeartHandshake",
        title: "I nostri servizi",
        text: "Cura della persona e assistenza infermieristica, su misura per voi.",
        to: "services",
        cta: "Servizi",
      },
      {
        icon: "Newspaper",
        title: "Novità e offerte di lavoro",
        text: "Notizie dal nostro servizio e posizioni aperte nel settore dell'assistenza.",
        to: "news",
        cta: "Novità",
      },
    ],
    servicesEyebrow: "I nostri servizi",
    servicesTitle: "Un'assistenza individuale, secondo le vostre esigenze",
    servicesLead:
      "Dalla cura della persona alla reperibilità 24 ore su 24: vi accompagniamo in modo completo nella vostra casa.",
    valuesEyebrow: "I nostri valori",
    valuesTitle: "Rispetto, premura e senso di responsabilità",
    valuesLead:
      "Rispetto, premura e senso di responsabilità sono i nostri principi fondamentali. Trattiamo ogni persona come vorremmo essere trattati noi stessi.",
    ctaTitle: "Non sapete quale grado di assistenza vi spetta?",
    ctaLead: "Saremo lieti di consigliarvi di persona, nella nostra sede o a casa vostra. Gratuitamente e senza impegno.",
  },

  values: [
    { icon: "Heart", label: "Assistenza individuale" },
    { icon: "BadgeCheck", label: "Personale infermieristico qualificato" },
    { icon: "MessageCircle", label: "Consulenza personale" },
    { icon: "ShieldCheck", label: "Senso di responsabilità" },
  ],

  services: [
    {
      id: "grundpflege",
      icon: "HandHeart",
      title: "Cura della persona",
      short: "Igiene, mobilizzazione e sostegno nella vita quotidiana, con calma e dignità.",
      description:
        "Nella cura della persona vi sosteniamo con sensibilità in tutte le attività quotidiane legate all'igiene e alla mobilità. Ci prendiamo il tempo e rispettiamo sempre la vostra dignità e la vostra autonomia.",
      points: [
        "Igiene personale (lavarsi, bagno, doccia)",
        "Mobilizzazione e posizionamento",
        "Assistenza in caso di incontinenza",
        "Aiuto durante i pasti",
        "Vestirsi e svestirsi",
      ],
    },
    {
      id: "behandlungspflege",
      icon: "Stethoscope",
      title: "Assistenza infermieristica",
      short: "Cure mediche su prescrizione del medico, affidabili e professionali.",
      description:
        "L'assistenza infermieristica comprende tutte le prestazioni necessarie dal punto di vista medico e viene sempre effettuata su prescrizione del medico. Il nostro personale qualificato collabora strettamente con i vostri medici.",
      points: [
        "Somministrazione e preparazione dei farmaci",
        "Iniezioni",
        "Applicazione e rimozione delle calze compressive",
        "Trattamento moderno delle ferite",
        "Controllo della glicemia e della pressione",
      ],
      note: "L'assistenza infermieristica viene sempre effettuata su prescrizione del medico.",
    },
    {
      id: "hauswirtschaft",
      icon: "Home",
      title: "Aiuto domestico",
      short: "Ci occupiamo della casa, perché possiate sentirvi davvero a vostro agio.",
      description:
        "Una casa curata contribuisce molto al benessere. Vi aiutiamo nella gestione domestica, perché tra le vostre quattro mura possiate sentirvi sereni e protetti.",
      points: [
        "Spesa e commissioni",
        "Preparazione dei pasti",
        "Bucato",
        "Pulizia dell'abitazione",
      ],
    },
    {
      id: "betreuung",
      icon: "Users",
      title: "Servizi di accompagnamento aggiuntivi",
      short: "Tempo insieme, conversazione e attività per più gioia di vivere.",
      description:
        "Oltre all'assistenza, per noi conta molto la vicinanza umana. Alleggeriamo i familiari che si prendono cura dei loro cari e vi regaliamo tempo per bei momenti insieme.",
      points: [
        "Sollievo per i familiari che assistono",
        "Esercizi di orientamento",
        "Conversazione e compagnia",
        "Lavoro biografico",
      ],
    },
    {
      id: "anleitung",
      icon: "GraduationCap",
      title: "Formazione per i familiari che assistono",
      short: "Aiutiamo i vostri familiari ad aiutarvi.",
      description:
        "I familiari che assistono fanno un lavoro straordinario. Offriamo indicazioni pratiche e sicurezza nell'assistenza, in modo individuale e comprensibile, direttamente a casa vostra.",
      points: [
        "Istruzioni pratiche di assistenza a domicilio",
        "Consulenza sugli ausili",
        "Consigli per la vita quotidiana con l'assistenza",
        "Sicurezza nella gestione dell'assistenza",
      ],
    },
    {
      id: "erreichbarkeit",
      icon: "Clock",
      title: "Reperibilità 24 ore su 24",
      short: "Raggiungibili sul cellulare a qualsiasi ora, perché possiate sentirvi al sicuro.",
      description:
        "In caso di emergenza siamo al vostro fianco a qualsiasi ora del giorno e della notte. Il nostro numero di emergenza mobile è attivo 24 ore su 24.",
      points: [
        "Numero di emergenza mobile: 0177 / 7202956",
        "In alternativa: 0157 / 36442746",
        "Aiuto rapido in caso di necessità",
        "Sicurezza per voi e per i vostri familiari",
      ],
    },
  ],

  servicesPage: {
    eyebrow: "Servizi",
    title: "Un'assistenza completa, su misura per voi",
    subtitle:
      "Vi offriamo un'ampia gamma di prestazioni di assistenza e di aiuto domestico, adattate con precisione alla vostra situazione.",
    shortLongTitle: "Assistenza temporanea e continuativa",
    shortLongText:
      "Per un periodo limitato dopo un ricovero o in modo continuativo: adattiamo la nostra assistenza con flessibilità alla vostra situazione di vita. Così ricevete esattamente il sostegno di cui avete bisogno in questo momento.",
    adviceTitle: "Consulenza sui gradi di assistenza e sulla cassa di assistenza",
    adviceText:
      "Il sistema dell'assistenza è complesso. Vi spieghiamo in modo chiaro quali prestazioni vi spettano e vi accompagniamo passo dopo passo nella richiesta alla cassa di assistenza.",
    ctaTitle: "Richiedete una consulenza gratuita",
    ctaLead: "Saremo lieti di consigliarvi di persona e senza impegno, nella nostra sede o a casa vostra.",
  },

  about: {
    eyebrow: "Chi siamo",
    title: "Persone che si prendono il tempo",
    subtitle:
      "Conoscete il nostro team e la nostra filosofia. Ci contraddistinguono tempo, rispetto, premura e autentica umanità.",
    introTitle: "Il vostro benessere al centro",
    intro: [
      "Siamo il team del Nieder-Eschbacher Pflegedienst di Francoforte sul Meno. Giorno dopo giorno ci impegniamo per le persone che ci danno fiducia. Per noi l'assistenza è molto più di un compito. È una questione di cuore.",
      "Il nostro personale cordiale e qualificato si prende consapevolmente il tempo per voi. Perché una buona assistenza ha bisogno di calma, attenzione e ascolto, senza fretta.",
      "Vi assistiamo dove vi sentite meglio: a casa vostra, nel vostro ambiente familiare. Così conservate la vostra autonomia e la vostra privacy.",
    ],
    teamImgAlt: "Un'operatrice tiene con premura le mani di una signora anziana in sedia a rotelle (immagine illustrativa)",
    valuesTitle: "I valori che ci guidano",
    valuesLead: "Rispetto, premura e senso di responsabilità sono i nostri principi fondamentali.",
    pillars: [
      { icon: "Clock", title: "Tempo", text: "Lavoriamo senza fretta e vi dedichiamo un'attenzione autentica." },
      { icon: "Heart", title: "Premura", text: "Ogni persona è unica. Lo è anche la nostra assistenza." },
      { icon: "Home", title: "Casa", text: "Assistenza nell'ambiente familiare, che dà sicurezza." },
    ],
    ctaTitle: "Venite a conoscerci",
    ctaLead: "Saremo lieti di incontrarvi per un colloquio personale.",
  },

  newsPage: {
    eyebrow: "Novità",
    title: "Novità e offerte di lavoro",
    subtitle: "Notizie dal nostro servizio di assistenza e posizioni aperte per chi desidera entrare a far parte del nostro team.",
    newsTitle: "Novità",
    newsLead: "Informazioni aggiornate dal nostro servizio di assistenza.",
    careerEyebrow: "Lavora con noi",
    careerTitle: "Entrate a far parte del nostro team",
    careerLead:
      "Amate l'assistenza e desiderate lavorare in un team cordiale che ha davvero tempo per le persone? Allora aspettiamo la vostra candidatura.",
    applyNow: "Candidati ora",
    applySubject: "Candidatura: Operatore/trice di assistenza (f/m/d)",
    tasks: "Le vostre mansioni",
    profile: "Il vostro profilo",
    offer: "Offriamo",
    interested: "Interessati? Inviate la vostra candidatura a",
    orCall: "oppure chiamateci al numero",
    questions: "Domande? Contattateci",
  },

  news: [
    {
      id: "willkommen",
      date: "2026-09-21",
      category: "Novità",
      title: "Benvenuti sul nostro nuovo sito web",
      excerpt:
        "Siamo lieti di potervi presentare da oggi anche online il nostro servizio di assistenza e le nostre prestazioni: in modo chiaro, ordinato e sempre accessibile.",
      body: "Il nostro obiettivo è rendere facilmente accessibili a voi e ai vostri familiari tutte le informazioni importanti sull'assistenza a domicilio. Per qualsiasi domanda potete contattarci in ogni momento per telefono o tramite il modulo di contatto.",
    },
    {
      id: "pflegeberatung",
      date: "2025-10-28",
      category: "Consulenza",
      title: "Consulenza gratuita sull'assistenza, nella nostra sede o a casa vostra",
      excerpt:
        "Non sapete quale grado di assistenza fa al caso vostro? Vi consigliamo volentieri di persona e senza impegno su tutte le questioni relative alla cassa di assistenza e ai gradi di assistenza.",
      body: "Il sistema tedesco dell'assistenza è complesso. Ci prendiamo il tempo, vi spieghiamo con calma le possibilità e vi sosteniamo nella richiesta delle prestazioni. Basta fissare un appuntamento.",
    },
    {
      id: "team-verstaerkung",
      date: "2025-10-05",
      category: "Team",
      title: "Cresciamo e cerchiamo nuovi collaboratori",
      excerpt:
        "Il nostro team cresce costantemente. Entrate a far parte di un gruppo cordiale che vive l'assistenza con tempo e rispetto.",
      body: "Offriamo condizioni di lavoro eque, un ambiente rispettoso e tempo vero per le persone che assistiamo. Date un'occhiata alle nostre offerte di lavoro attuali.",
    },
  ],

  jobs: [
    {
      id: "pflegehelfer",
      title: "Operatore/trice di assistenza (f/m/d)",
      type: "Part-time o tempo pieno",
      location: "Francoforte sul Meno, Nieder-Eschbach",
      intro:
        "Per rafforzare il nostro team cerchiamo un operatore o un'operatrice di assistenza che dia vita ai nostri valori: tempo, rispetto e premura. Sono benvenuti anche coloro che cambiano professione e hanno il cuore per questo lavoro.",
      tasks: [
        "Sostegno nella cura della persona dei nostri assistiti",
        "Aiuto nella mobilizzazione e nella vita quotidiana",
        "Accompagnamento e vicinanza umana",
        "Stretta collaborazione all'interno del team di assistenza",
      ],
      requirements: [
        "Piacere nel lavorare con le persone ed empatia",
        "Affidabilità, senso di responsabilità e spirito di squadra",
        "Una prima esperienza nell'assistenza è gradita (non obbligatoria)",
        "Patente di categoria B gradita",
      ],
      offer: [
        "Retribuzione equa e puntuale",
        "Un team cordiale e rispettoso",
        "Tempo vero per l'assistenza, senza fretta",
        "Inserimento e formazione continua",
      ],
    },
  ],

  contact: {
    eyebrow: "Contatti",
    title: "Siamo qui per voi",
    subtitle:
      "Domande sull'assistenza, richiesta di appuntamento o consulenza: contattateci senza impegno. Saremo lieti di sentirvi.",
    formTitle: "Scriveteci",
    formLead: "Vi risponderemo il prima possibile.",
    name: "Nome e cognome",
    namePlaceholder: "Il vostro nome",
    email: "E-mail",
    emailPlaceholder: "nome@esempio.de",
    phone: "Telefono",
    phonePlaceholder: "Il vostro numero di telefono",
    message: "Messaggio",
    messagePlaceholder: "Come possiamo aiutarvi?",
    consentBefore: "Ho letto",
    consentLink: "l'informativa sulla privacy",
    consentAfter:
      "e acconsento al trattamento dei miei dati (comprese eventuali informazioni sulla salute contenute nel messaggio) per la gestione della mia richiesta. Posso revocare il consenso in qualsiasi momento.",
    submit: "Invia il messaggio",
    sending: "Invio in corso…",
    subject: "Richiesta tramite il sito web",
    errName: "Inserite il vostro nome.",
    errEmail: "Inserite un indirizzo e-mail valido.",
    errMessage: "Scriveteci un breve messaggio.",
    errConsent: "Accettate l'informativa sulla privacy.",
    toastCheck: "Controllate i dati inseriti.",
    toastSuccess: "Grazie! Il vostro messaggio è stato inviato.",
    toastError: "Si è verificato un errore. Vi preghiamo di chiamarci.",
    successTitle: "Grazie!",
    successText: "Il vostro messaggio è stato inviato. Vi ricontatteremo al più presto.",
    sendAnother: "Invia un altro messaggio",
    reachTitle: "Come raggiungerci",
    address: "Indirizzo",
    phoneLabel: "Telefono",
    fax: "Fax",
    emergency: "Numero di emergenza 24 ore",
    alternatively: "in alternativa",
    emailLabel: "E-mail",
    hoursTitle: "Orari dell'ufficio",
    hours: "Dal lunedì al venerdì: dalle 08:00 alle 17:00",
    careAndEmergency: "Assistenza ed emergenze:",
    aroundTheClock: "24 ore su 24",
    mapTitle: "Dove siamo",
    mapIframeTitle: "Sede del Nieder-Eschbacher Pflegedienst su Google Maps",
    mapLoad: "Carica la mappa",
    mapNotice:
      "Per motivi di privacy la mappa di Google Maps viene caricata solo dopo il vostro consenso. In tal caso vengono trasmessi dati a Google.",
    mapButton: "Carica la mappa e mostra la sede",
    mapAlt: "Oppure apri in Google Maps",
  },

  reviews: {
    eyebrow: "Recensioni",
    title: "Cosa dicono familiari e pazienti",
    emptyLead: "La vostra esperienza aiuta altre famiglie di Francoforte a trovare il servizio di assistenza giusto.",
    countOn: "recensioni su",
    source: "Recensioni pubbliche dal nostro Profilo dell'attività su Google.",
    asOf: "Aggiornato a:",
    all: "Tutte le recensioni su Google",
    write: "Scrivi una recensione",
    on: "su",
    starsLabel: "su 5 stelle",
  },

  notFound: {
    title: "Pagina non trovata",
    subtitle: "Errore 404",
    text: "La pagina richiesta non esiste o è stata spostata.",
    home: "Torna alla home",
  },

  imprint: {
    title: "Note legali",
    subtitle: "Informazioni ai sensi del § 5 della legge tedesca sui servizi digitali (DDG)",
    company: "Informazioni ai sensi del § 5 DDG",
    country: "Germania",
    representedBy: "Rappresentata da",
    managingDirector: "Amministratrice",
    contact: "Contatti",
    phone: "Telefono",
    fax: "Fax",
    email: "E-mail",
    register: "Iscrizione al registro",
    registerCourt: "Tribunale del registro",
    registerNumber: "Numero di registro",
    taxNumber: "Codice fiscale",
    licence: "Autorizzazione e autorità di vigilanza",
    licenceText:
      "Servizio di assistenza domiciliare autorizzato tramite contratto di assistenza ai sensi del § 72 del Codice sociale, libro XI (SGB XI), con le associazioni regionali delle casse di assistenza dell'Assia.",
    authorityText:
      "Autorità di vigilanza competente ai sensi della legge dell'Assia sui servizi di accompagnamento e assistenza (HGBP):",
    dispute: "Risoluzione delle controversie dei consumatori",
    disputeText:
      "Non siamo disposti né obbligati a partecipare a procedure di risoluzione delle controversie dinanzi a un organismo di conciliazione per i consumatori (§ 36 VSBG).",
    responsible: "Responsabile dei contenuti ai sensi del § 18 comma 2 del Trattato interstatale sui media (MStV)",
    credit: "Concezione e realizzazione tecnica",
    liabilityContent: "Responsabilità per i contenuti",
    liabilityContentText:
      "In qualità di fornitore di servizi siamo responsabili dei contenuti propri di queste pagine secondo le leggi generali. Non siamo tuttavia tenuti a sorvegliare le informazioni di terzi trasmesse o memorizzate, né a ricercare circostanze che indichino un'attività illecita (art. 8 del Regolamento (UE) 2022/2065, legge sui servizi digitali). Restano impregiudicati gli obblighi di rimozione o blocco dell'uso di informazioni ai sensi delle leggi generali. Una responsabilità in tal senso è possibile solo dal momento in cui si viene a conoscenza di una concreta violazione di legge. Non appena verremo a conoscenza di tali violazioni, rimuoveremo immediatamente i contenuti in questione.",
    liabilityLinks: "Responsabilità per i link",
    liabilityLinksText:
      "Il nostro sito contiene link a siti web esterni di terzi, sui cui contenuti non abbiamo alcuna influenza. Per questo non possiamo assumerci alcuna garanzia per tali contenuti. Del contenuto delle pagine collegate è sempre responsabile il rispettivo fornitore o gestore. Le pagine collegate sono state verificate al momento del collegamento per possibili violazioni di legge; contenuti illeciti non erano riconoscibili in quel momento. Un controllo permanente dei contenuti delle pagine collegate non è ragionevolmente esigibile senza indizi concreti di una violazione. Non appena verremo a conoscenza di violazioni, rimuoveremo immediatamente tali link.",
    copyright: "Diritto d'autore",
    copyrightText:
      "I contenuti e le opere creati dal gestore del sito su queste pagine sono soggetti al diritto d'autore tedesco. La riproduzione, l'elaborazione, la diffusione e qualsiasi forma di utilizzo al di fuori dei limiti del diritto d'autore richiedono il consenso scritto del rispettivo autore o creatore. Download e copie di questo sito sono consentiti solo per uso privato e non commerciale. Nella misura in cui i contenuti di questo sito non sono stati creati dal gestore, vengono rispettati i diritti d'autore di terzi; in particolare, i contenuti di terzi sono contrassegnati come tali. Se doveste comunque notare una violazione del diritto d'autore, vi preghiamo di segnalarcela. Non appena verremo a conoscenza di violazioni, rimuoveremo immediatamente tali contenuti.",
  },

  privacy: {
    title: "Informativa sulla privacy",
    subtitle: "Informazioni sul trattamento dei vostri dati personali ai sensi del GDPR",
    retention: "sei mesi",
    lastUpdated: "Aggiornato a: ottobre 2026",
    controller: {
      title: "1. Titolare del trattamento",
      lead: "Il titolare del trattamento dei dati su questo sito web ai sensi del Regolamento generale sulla protezione dei dati (GDPR) è:",
      representedBy: "rappresentata dall'amministratrice",
      phone: "Telefono",
      fax: "Fax",
      email: "E-mail",
    },
    dpo: {
      title: "Responsabile della protezione dei dati",
      lead: "Potete contattare il nostro responsabile della protezione dei dati all'indirizzo:",
    },
    general: {
      title: "2. Informazioni generali sul trattamento dei dati",
      p: [
        "Trattiamo i dati personali solo nella misura necessaria a fornire un sito web funzionante e a gestire le vostre richieste. Le basi giuridiche sono l'art. 6 par. 1 lett. a GDPR (consenso), l'art. 6 par. 1 lett. b GDPR (contratto o misure precontrattuali) e l'art. 6 par. 1 lett. f GDPR (interesse legittimo a un funzionamento sicuro e stabile di questo sito).",
        "Questo sito **non utilizza cookie**, non memorizza informazioni sul vostro dispositivo (§ 25 TDDDG) e non impiega servizi di analisi, tracciamento o pubblicità. Font e immagini vengono forniti dal nostro server; all'apertura delle pagine non vengono trasmessi dati a servizi di font o immagini di terzi. Non ha luogo alcun processo decisionale automatizzato, compresa la profilazione (art. 22 GDPR).",
      ],
    },
    hosting: {
      title: "3. Hosting e file di log del server",
      ownIntro:
        "Questo sito è gestito per nostro conto da {operator} su un server in Germania. Il fornitore del centro dati e del server è {provider}.",
      logs: "A ogni accesso vengono trattati i dati di connessione tecnicamente necessari: indirizzo IP, data e ora dell'accesso, pagina richiesta, quantità di dati trasferiti, tipo e versione del browser, sistema operativo e pagina visitata in precedenza (referrer). Questi dati non vengono combinati con altre fonti e servono esclusivamente alla fornitura del sito, alla sicurezza e all'analisi degli errori. La base giuridica è l'art. 6 par. 1 lett. f GDPR. I file di log del server vengono conservati solo per il tempo necessario a un funzionamento sicuro e poi cancellati o resi anonimi.",
      ownLegal:
        "Con il gestore e con il fornitore del centro dati sono in essere contratti di trattamento dei dati ai sensi dell'art. 28 GDPR. Nell'ambito dell'hosting non avviene alcun trasferimento verso paesi terzi.",
    },
    form: {
      title: "4. Modulo di contatto",
      p: [
        "Se ci inviate una richiesta tramite il modulo di contatto, trattiamo i dati da voi inseriti (nome, indirizzo e-mail, facoltativamente il numero di telefono e il vostro messaggio) per gestire la richiesta ed eventuali domande successive. La base giuridica è l'art. 6 par. 1 lett. b GDPR (avvio di un rapporto di assistenza) e, se ci comunicate informazioni sulla salute, il vostro consenso esplicito ai sensi dell'art. 9 par. 2 lett. a GDPR, che esprimete tramite la casella di controllo nel modulo.",
        "I campi obbligatori sono nome, indirizzo e-mail e messaggio; il numero di telefono è facoltativo. Senza i dati obbligatori non possiamo gestire la vostra richiesta; in tal caso potete sempre contattarci telefonicamente. La trasmissione avviene in forma cifrata (TLS). La vostra richiesta viene memorizzata esclusivamente su un server in Germania da noi incaricato e non viene trasmessa a terzi. Cancelliamo i dati al più tardi {retention} dopo la gestione definitiva della vostra richiesta, se non si instaura un rapporto di assistenza e non vi si oppongono obblighi di conservazione di legge. Potete revocare il consenso in qualsiasi momento con effetto per il futuro, ad esempio scrivendo a {email}.",
      ],
    },
    emailPhone: {
      title: "5. Contatto tramite e-mail, telefono o WhatsApp",
      p: [
        "Se ci contattate tramite e-mail o telefono, trattiamo i vostri dati per gestire la richiesta (art. 6 par. 1 lett. b e lett. f GDPR). Tenete presente che le e-mail non cifrate possono essere lette da terzi durante la trasmissione; per informazioni sulla salute consigliamo il telefono o un colloquio di persona.",
        "Le e-mail inviate a {email} ci raggiungono tramite un servizio di inoltro: la consegna è curata da {forwarder} e la casella è ospitata presso {mailbox}. Nel corso di questo processo vengono trattati il vostro indirizzo mittente, l'oggetto e il contenuto del messaggio, con trasferimento anche negli USA. La base giuridica è l'art. 6 par. 1 lett. f GDPR. Vi preghiamo pertanto di non inviare dati sulla salute per e-mail e di usare il telefono o un colloquio di persona.",
        "Sul nostro sito trovate un link che vi permette di scriverci su WhatsApp. Il fornitore è WhatsApp Ireland Limited, 4 Grand Canal Square, Grand Canal Harbour, Dublino 2, Irlanda. Il link è un semplice rimando: solo quando lo cliccate viene stabilita una connessione con WhatsApp e il vostro numero di cellulare e il contenuto del messaggio vengono trasmessi a WhatsApp. La base giuridica è l'art. 6 par. 1 lett. b GDPR. WhatsApp tratta dati anche fuori dall'UE; Meta è certificata ai sensi dell'EU-US Data Privacy Framework. Non inviateci dati sulla salute tramite WhatsApp e in caso di emergenza usate il telefono.",
      ],
    },
    applications: {
      title: "6. Candidature",
      p: [
        "Le candidature per le nostre offerte di lavoro ci vengono inviate tramite e-mail. Trattiamo i vostri documenti di candidatura esclusivamente per lo svolgimento della procedura di selezione (art. 6 par. 1 lett. b GDPR, § 26 BDSG). Al termine della procedura i documenti vengono cancellati al più tardi dopo sei mesi, a meno che non abbiate acconsentito a una conservazione più lunga o non si instauri un rapporto di lavoro.",
      ],
    },
    maps: {
      title: "7. Google Maps (soluzione a due clic)",
      p: [
        "Nella pagina dei contatti offriamo una mappa del servizio Google Maps. Il fornitore è Google Ireland Limited, Gordon House, Barrow Street, Dublino 4, Irlanda. La mappa viene caricata **solo dopo il vostro clic esplicito** su «Carica la mappa»; prima di allora non viene trasmesso alcun dato a Google. Con il clic acconsentite (art. 6 par. 1 lett. a GDPR) a che Google tratti il vostro indirizzo IP e i dati di utilizzo e li trasferisca eventualmente ai server di Google LLC negli USA; in tale contesto Google può impostare cookie sul vostro dispositivo. Google è certificata ai sensi dell'EU-US Data Privacy Framework e utilizza in aggiunta clausole contrattuali standard. Il vostro consenso vale solo per la visualizzazione corrente della pagina. Ulteriori informazioni: [policies.google.com/privacy](https://policies.google.com/privacy).",
      ],
    },
    rights: {
      title: "8. I vostri diritti",
      lead: "In relazione ai vostri dati personali avete nei nostri confronti i seguenti diritti:",
      items: [
        "Accesso (art. 15 GDPR)",
        "Rettifica (art. 16 GDPR)",
        "Cancellazione (art. 17 GDPR)",
        "Limitazione del trattamento (art. 18 GDPR)",
        "Portabilità dei dati (art. 20 GDPR)",
        "Opposizione ai trattamenti basati sull'art. 6 par. 1 lett. f GDPR (art. 21 GDPR)",
        "Revoca dei consensi prestati con effetto per il futuro (art. 7 par. 3 GDPR)",
      ],
      how: "Per esercitare i vostri diritti è sufficiente una comunicazione informale a {email} o per posta all'indirizzo sopra indicato.",
    },
    authority: {
      title: "9. Diritto di reclamo all'autorità di controllo",
      lead: "Avete il diritto di proporre reclamo a un'autorità di controllo per la protezione dei dati (art. 77 GDPR). L'autorità competente per noi è:",
      name: "Il Garante dell'Assia per la protezione dei dati e la libertà di informazione",
      address: "Gustav-Stresemann-Ring 1, 65189 Wiesbaden, Germania",
      url: "https://datenschutz.hessen.de",
      urlLabel: "datenschutz.hessen.de",
    },
    security: {
      title: "10. Sicurezza dei dati",
      p: [
        "Questo sito viene fornito esclusivamente tramite una connessione HTTPS cifrata (TLS). Adottiamo misure tecniche e organizzative per proteggere i vostri dati da perdita, manipolazione e accesso non autorizzato e le adeguiamo costantemente allo stato della tecnica.",
      ],
    },
    changes: {
      title: "11. Modifiche di questa informativa sulla privacy",
      p: [
        "Aggiorniamo questa informativa sulla privacy quando cambia la situazione giuridica o il nostro sito web. Vale la versione pubblicata qui.",
      ],
    },
  },
};

export default it;
